import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import { isNotNullOrUndefined } from 'Util/TypeGuards';

export interface IParkingVehicleTypeEntityAttributes extends IModelAttributes {
	name: string;
	description?: string;
	iconName?: string;
	disabled?: boolean;
}

@entity('ParkingVehicleTypeEntity', 'Parking Vehicle Type')
export default class ParkingVehicleTypeEntity extends Model implements IParkingVehicleTypeEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute<ParkingVehicleTypeEntity, string>()
	public name: string;

	@observable
	@attribute<ParkingVehicleTypeEntity, string>()
	public description?: string;

	@observable
	@attribute<ParkingVehicleTypeEntity, string>()
	public iconName?: string;

	@observable
	@attribute<ParkingVehicleTypeEntity, boolean>()
	public disabled?: boolean;

	constructor(attributes?: Partial<IParkingVehicleTypeEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IParkingVehicleTypeEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (isNotNullOrUndefined(attributes.name)) {
				this.name = attributes.name;
			}
			if (isNotNullOrUndefined(attributes.description)) {
				this.description = attributes.description;
			}
			if (isNotNullOrUndefined(attributes.iconName)) {
				this.iconName = attributes.iconName;
			}
			if (isNotNullOrUndefined(attributes.disabled)) {
				this.disabled = attributes.disabled;
			}
		}
	}
}
